import { z } from 'zod';

import { BaseLoanIdSideEffect } from './BaseLoanIdSideEffect';

export const GeneratePreActiveWelcomeLetterSideEffect = BaseLoanIdSideEffect.extend({
  type: z.literal('generatePreActiveWelcomeLetter'),
});
export type GeneratePreActiveWelcomeLetterSideEffect = z.infer<typeof GeneratePreActiveWelcomeLetterSideEffect>;
